import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';

import {
    MaintainTopWrapper,
    Title,
    Text,
    MaintainBottomWrapper,
    MaintainBottomTextWrap,
    MaintainBottomText,
    MaintainBottomText1,
    Logo,
    MaintainLogo
} from './Maintain.style';
import i18n from '../../i18n';
class Maintain extends Component {
    render() {
        const {startDate , endDate, description , isServerCheck , editWindow} = this.props
        return (
            <div>
            <Dialog  open={isServerCheck} >
                 <div className="closeBtn" onClick={this.props.maintainCloseBtn}>
                    <div className="closeBar1" />
                    <div className="closeBar2" />
                </div>
                <MaintainTopWrapper>
                    <MaintainLogo src="https://front.videomonster.com/images-7cuytg20/web/maintainlogo.png" alt=""></MaintainLogo>
                    <div style={{textAlign :"left"}}>
                    <Logo src="https://front.videomonster.com/images-7cuytg20/web/loginbiglogo.png" alt="" />
                    </div>
                    
                    <Title lang={this.props.value} style={{fontSize : this.props.value ==="en" ? "32px" : "38px"}}>{editWindow ? 
                    `${i18n.t("maintain.title1-1")}
                    ${i18n.t("maintain.title1-2")}`: 
                        `${i18n.t("maintain.title2-1")}
                        ${i18n.t("maintain.title2-2")}
                        `}</Title>
                    <Text lang={this.props.value}>{editWindow?
                    `${i18n.t("maintain.title3-1")} 
                    ${i18n.t("maintain.title3-2")}` :
                    `${i18n.t("maintain.title4")}
                    ${i18n.t("maintain.title5")}`}</Text>
                </MaintainTopWrapper>

                <MaintainBottomWrapper>
                    <MaintainBottomTextWrap>
                        <MaintainBottomText1 lang={this.props.value}>
                        {i18n.t("maintain.MaintainBottomText1")}
                        </MaintainBottomText1>
                        <MaintainBottomText lang={this.props.value}>
                            {`${startDate} ~ ${endDate} (KST) `}
                        </MaintainBottomText>
                    </MaintainBottomTextWrap>
                    <MaintainBottomTextWrap>
                        <MaintainBottomText1 lang={this.props.value}>
                        {i18n.t("maintain.MaintainBottomText2")}
                        </MaintainBottomText1>
                        <MaintainBottomText lang={this.props.value}>
                            {`${description}`}
                        </MaintainBottomText>
                    </MaintainBottomTextWrap>
                </MaintainBottomWrapper>
            </Dialog>
            </div>
        );
    }
}

export default Maintain;